<template>
  <aside
    class="sidebar-config"
    :class="{'is-empty': !hasConfigurations, 'sidebar-open': open}"
    v-click-outside="handleOutsideClick"
  >
    <header class="sidebar-config__header">
      <h2
        class="heading"
        v-html="$t('myConfigurations')"
      ></h2>
    </header>
    <sidebar-empty
      v-if="!hasConfigurations && !hasFiles"
      :show-order-quote="hasConfigurations"
      :show-start-button="!hasConfigurations && !configuratorOpened"
    />
     <div
      class="sidebar-config__item scrollbar"
    >
      <div
        class="item-block item-block--edit"
        v-if="files.length > 0"
      >
        <div class="row">
          <div class="col-12">
            <span>{{ infoText }}</span>
            <a
              class="btn-main btn-main--white"
              href="#"
              @click.prevent="handleEditFiles"
            >
              {{ $t('editFiles') }}
            </a>
          </div>
        </div>
      </div>

      <template v-if="hasConfigurations">
        <sidebar-item
          v-for="item in configurations"
          :key="item.id"
          :item="item"
          :on-edit="() => handleItemEdit(item)"
          :on-copy="() => handleItemCopy(item)"
          :on-remove="() => handleItemRemove(item)"
        />
      </template>
    </div>
    <sidebar-cookies
      v-if="cookieAgreementOpen"
      :on-accept="acceptCookieAgreement"
    />
    <sidebar-summary
      v-if="hasConfigurations && !cookieAgreementOpen"
      :total-configurations="configurations.length"
      :total-windows="totalWindows"
      :on-order-quote="handleOrderQuote"
    />
  </aside>
</template>

<script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  import SidebarEmpty from './SidebarEmpty.vue';
  import SidebarItem from './SidebarItem.vue';
  import SidebarSummary from './SidebarSummary.vue';
  import SidebarCookies from './SidebarCookies.vue';

  export default {
    name: 'ConfigurationSidebar',
    data() {
      return {
        cookieAgreementOpen: false,
      };
    },
    created() {
      if (!this.hasAccepetedCookieAgreement() === true) {
        this.cookieAgreementOpen = true;
      }
    },
    methods: {
      ...mapActions({
        openOrderQuoteModal: 'openOrderQuoteModal',
        cloneConfiguration: 'cloneConfiguration',
        setCurrentStep: 'configurator/setCurrentStep',
      }),
      ...mapMutations({
        removeConfiguration: 'removeConfiguration',
        hide: 'hideConfigurationsSidebar',
      }),
      handleOutsideClick() {
        if (this.open) {
          this.hide();
        }
      },
      handleItemEdit(item) {
        const { $router, configurationType } = this;
        $router.push({
          name: 'configurator',
          query: {
            type: configurationType,
            id: item.id,
          },
        });
        this.hide();
      },
      handleItemCopy(item) {
        this.cloneConfiguration(item.id);
      },
      handleItemRemove(item) {
        this.removeConfiguration(item.id);
      },
      handleOrderQuote() {
        this.openOrderQuoteModal();
      },
      handleEditFiles() {
        this.setCurrentStep({ stepId: 'files' });
      },
      acceptCookieAgreement() {
        localStorage.setItem('cookie:accepted', true);
        this.cookieAgreementOpen = false;
      },
      hasAccepetedCookieAgreement() {
        return localStorage.getItem('cookie:accepted');
      },
    },
    computed: {
      ...mapState({
        configurationType: state => state.configurationType,
        configurations: state => state.configurations,
        configuratorOpened: state => state.configurator.opened,
        files: state => state.configurator.files,
        open: state => state.configurationsSidebar.open,
      }),
      ...mapGetters({
        hasConfigurations: 'hasConfigurations',
      }),
      summaryClass() {
        const { cookieAgreementOpen } = this;
        return {
          'is-cookies': cookieAgreementOpen,
        };
      },
      totalWindows() {
        const { configurations = [] } = this;

        if (configurations.length === 0) {
          return 0;
        }

        return configurations.reduce(
          (total, item) => (item.count ? total + item.count : total),
          0,
        );
      },
      hasFiles() {
        return this.files.length > 0;
      },
      infoText() {
        const { $t, files } = this;

        return $t('youAddedAmountOfFiles', {
          amount: files.length,
          filesText: $t('files', { count: files.length }),
        });
      },
    },
    components: {
      SidebarEmpty,
      SidebarItem,
      SidebarSummary,
      SidebarCookies,
    },
  };
</script>
